import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Plus } from "lucide-react";
import PlayerQuickEditor from "./PlayerQuickEditor";

const BLANK_PLAYER = { name: "", league: "PWHL", team_id: "", position: "", jersey: "", shoots: "", height_cm: "", birthdate: "", nationality: "", birthplace: "", photo_url: "", stats: {}, contracts: [], awards: [] };

// Clicking it opens the standard player editor in create mode. The editor is rendered via a PORTAL to
// document.body so it escapes the nav bar's stacking context and overlays the
// page exactly like the "Edit" pop-up does on a player's bio page.
// Owner "+" that sits at the END of the search bar input.
export default function OwnerQuickAdd({ compact = false }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="shrink-0 self-stretch flex" data-testid="owner-quick-add">
            <button type="button" data-testid="owner-quick-add-tile"
                onClick={() => setOpen(true)}
                title="Add new player"
                style={{ borderColor: "#F6C45366", color: "#F6C453" }}
                className={`${compact ? "w-7" : "w-9"} flex items-center justify-center rounded-lg border bg-black/30 transition-colors hover:brightness-125`}>
                <Plus className="h-4 w-4" strokeWidth={2.5} />
            </button>
            {open && ReactDOM.createPortal(
                <PlayerQuickEditor player={{ ...BLANK_PLAYER }} teamId="" onClose={() => setOpen(false)} />,
                document.body
            )}
        </div>
    );
}
